import { type DiscountAction, type DiscountDocument } from "@fitness-app/data-models/entities/Discount";

import { type RequestStatus } from "../../../enums/requestStatus";

export const DISCOUNT_REDUCER_NAME = "Discount";

export interface DiscountReducer {
  discountsListStatus: RequestStatus | null;
  discounts: DiscountDocument[];
  discountAction: null | { id: string; action: DiscountAction };
  discountsError: string | null;
  addingNewDiscount: boolean;
}
